import { createI18n } from 'vue-i18n';

// Import translations
import en from './en.json';

const i18n = createI18n({
  legacy: false, // Set to false to use Composition API
  locale: 'en', // Set default locale
  fallbackLocale: 'en', // Set fallback locale
  messages: {
    en,
  },
});

export default i18n;
